import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Container = styled.div`
  width: 94px;
  height: 43px;
  border-radius: 3px;
  padding: 0px 8px;
  background-color: ${props => props.theme.bodyColor};
  border: none;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  font: ${props => props.theme.fontWeightBold} 8px/120% ${props => props.theme.fontFamilyBody};
  color: ${props => props.theme.secondaryColor};
  text-transform: uppercase;

  & > .percent {
    color: white;
    font-size: 19px;
    margin-bottom: 7px;
  }
`;

export default function Toolty({ active, payload }) {
  if (!active) {
    return null;
  }

  return (
    <Container>
      <span className="percent">{`${_.get(payload, '[0].payload.pct', 0)}%`}</span>
      <span>of total views</span>
    </Container>
  );
}

Toolty.propTypes = {
  active: PropTypes.bool,
  payload: PropTypes.arrayOf(PropTypes.shape({
    payload: PropTypes.shape({
      pct: PropTypes.number,
    }).isRequired,
  })).isRequired,
};

Toolty.defaultProps = {
  active: false,
};
